import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

export const RideNearbyNoSearch = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "ride-nearby-no-search-placeholder",
})`
  min-width: 15px;
`;
